import { Phone, Envelope, ClipboardText, Siren, Clock, ChatCircle, ChatText, User } from "@phosphor-icons/react";
import { STATUS_LABEL, STATUS_TONE, isRed, ago, hms, addressLine } from "./oohUtils";
import { SlaCountdown } from "./OohCalloutBits";

const SRC_ICON = { tenant_report: ClipboardText, email: Envelope, email_forward: Envelope, phone: Phone, whatsapp: ChatCircle, text: ChatText, in_person: User };

export function OohStatusPill({ c, testId }) {
  return (
    <span className={`inline-flex items-center gap-1 text-[10px] font-semibold uppercase tracking-wider px-2 py-0.5 rounded-full ${STATUS_TONE[c.status] || STATUS_TONE.closed}`} data-testid={testId}>
      {c.status === "callout" && <Siren size={10} weight="fill" />}{STATUS_LABEL[c.status] || c.status}
    </span>
  );
}

export function OohCaseRow({ c, active, onClick }) {
  const Icon = SRC_ICON[c.source] || Phone;
  const red = isRed(c);
  return (
    <button type="button" onClick={onClick} data-testid={`ooh-case-row-${c.id}`}
      className={`w-full text-left px-3 py-2.5 border-b border-border/60 transition-colors duration-200 ${active ? "bg-primary/10" : "hover:bg-muted/60"} ${red ? "border-l-4 border-l-red-600 bg-red-50/70 dark:bg-red-950/30" : ""}`}>
      <div className="flex items-center justify-between gap-2">
        <div className="flex items-center gap-2 min-w-0">
          <OohStatusPill c={c} />
          <span className="font-mono text-[11px] text-muted-foreground">{c.reference}</span>
        </div>
        <span className="text-[10px] text-muted-foreground whitespace-nowrap inline-flex items-center gap-1"><Clock size={10} /> {ago(c.received_at)}</span>
      </div>
      <p className={`text-sm font-medium mt-1 truncate ${red ? "text-red-800 dark:text-red-200" : ""}`}>{c.title}</p>
      <p className="text-xs text-muted-foreground truncate mt-0.5">
        <Icon size={11} className="inline mr-1 -mt-0.5" />{c.requester?.name || "Unknown"}{c.requester?.phone ? ` · ${c.requester.phone}` : ""}{addressLine(c.address) ? ` · ${addressLine(c.address)}` : ""}
      </p>
      {c.ai_summary && <p className="text-[11px] text-muted-foreground/90 mt-0.5 line-clamp-1">{c.ai_summary}</p>}
      {(c.call_count > 0 || c.linked?.emergency_ref || c.linked?.job_request_ref || c.sla) && (
        <p className="text-[10px] text-muted-foreground mt-1 flex gap-2 flex-wrap items-center">
          {c.sla && <SlaCountdown sla={c.sla} compact />}
          {c.contractor && <span className="font-semibold text-foreground/80">{c.contractor}</span>}
          {c.call_count > 0 && <span>{c.call_count} call{c.call_count === 1 ? "" : "s"} · {hms(c.call_seconds)}</span>}
          {c.linked?.emergency_ref && <span className="text-red-600 font-semibold">{c.linked.emergency_ref}</span>}
          {c.linked?.job_request_ref && <span className="text-sky-700 dark:text-sky-300 font-semibold">{c.linked.job_request_ref}</span>}
        </p>
      )}
    </button>
  );
}

export function OohEmpty({ view, active }) {
  const copy = view === "open" ? (active ? "Nothing waiting on the desk right now — new tenant reports, emails and call-ins will appear here the moment they land." : "The desk is quiet. Requests arriving after 17:00, at weekends or on bank holidays will land here.")
    : view === "urgent" ? "No call-outs open." : view === "handover" ? "Nothing handed over yet." : view === "closed" ? "No closed cases." : "No cases yet.";
  return <div className="p-8 text-center text-sm text-muted-foreground" data-testid="ooh-empty">{copy}</div>;
}
